var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Input from "@mui/joy/Input";
import { useGetPasswordManagerConfigQuery } from "@/store/api";
export var UserPassword = function (_a) {
    var _b, _c;
    var passData = _a.passData, record = _a.record, _d = _a.isAdminCreation, isAdminCreation = _d === void 0 ? false : _d, generatePwd = _a.generatePwd;
    var _e = useState(false), oldRequired = _e[0], setOldRequired = _e[1];
    var _f = useState(record.password
        ? record.password
        : {
            old: "",
            new: "",
            confirm: "",
        }), passValue = _f[0], setPassValue = _f[1];
    var configData = useGetPasswordManagerConfigQuery({}).data;
    var settingsPassValue = (_c = (_b = configData === null || configData === void 0 ? void 0 : configData.data) === null || _b === void 0 ? void 0 : _b.configs) === null || _c === void 0 ? void 0 : _c.password;
    var minpwdlength = settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.minpwdlength;
    var oneupper = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.oneupper) || "";
    var onelower = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.oneupper) || "";
    var onenumber = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.onenumber) || "";
    var onespecial = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.onespecial) || "";
    var validatePassword = function (password) {
        var specialRegex = /[#$%^&*()+=[\]';,./{}|:<>?~\-]/;
        if (minpwdlength && password.length < Number(minpwdlength)) {
            return t("LBL_PASSWORD_LENGTH", {
                ns: "Users",
                length: minpwdlength,
            });
        }
        if (oneupper && !/[A-Z]/.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_UPPERCASE", { ns: "Users" });
        }
        if (onelower && !/[a-z]/.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_LOWERCASE", { ns: "Users" });
        }
        if (onenumber && !/[0-9]/.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_NUMBER", { ns: "Users" });
        }
        if (onespecial && !specialRegex.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_SPECIAL", { ns: "Users" });
        }
        return "";
    };
    var _g = useState(""), passwordError = _g[0], setPasswordError = _g[1];
    var _h = useState(true), isMatch = _h[0], setIsmatch = _h[1];
    var changeNewPasword = function (e) {
        var newPassword = e.target.value;
        setPassValue(__assign(__assign({}, passValue), { new: newPassword }));
        var error = validatePassword(newPassword);
        setPasswordError(error);
        (passValue === null || passValue === void 0 ? void 0 : passValue.confirm) !== "" &&
            (passValue === null || passValue === void 0 ? void 0 : passValue.new) !== "" &&
            passValue.new !== passValue.confirm &&
            setIsmatch(false);
        //passValue.old === "" && setOldRequired(true);
        // Ancien mot de passe requis uniquement si ce n’est pas une création par admin
        if (!isAdminCreation && passValue.old === "") {
            setOldRequired(true);
        }
        else {
            setOldRequired(false);
        }
    };
    var changeConfirmPasword = function (e) {
        setPassValue(__assign(__assign({}, passValue), { confirm: e.target.value }));
        (passValue === null || passValue === void 0 ? void 0 : passValue.confirm) !== "" &&
            (passValue === null || passValue === void 0 ? void 0 : passValue.new) !== "" &&
            passValue.new !== passValue.confirm &&
            setIsmatch(false);
    };
    var changeOldPasword = function (e) {
        setPassValue(__assign(__assign({}, passValue), { old: e.target.value }));
        passValue.old !== "" && setOldRequired(false);
    };
    useEffect(function () {
        if (!generatePwd && isAdminCreation)
            return;
        (passValue.new === "" ||
            passValue.confirm === "" ||
            passValue.new === passValue.confirm) &&
            setIsmatch(true);
        passData(passValue);
    }, [passValue]);
    var t = useTranslation(["common", "Users"]).t;
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ id: "generate_password", className: "m-4 bg-white p-2 rounded-md shadow sm:p-4" }, { children: _jsx("table", __assign({ width: "100%", className: "edit view" }, { children: _jsx("tr", { children: _jsxs("td", __assign({ width: "40%" }, { children: [_jsx("div", __assign({ className: "border-b-2" }, { children: _jsx("table", __assign({ width: "20%", className: "border-gray-300 mb-2" }, { children: _jsx("tr", { children: _jsx("th", __assign({ align: "left" }, { children: _jsx("h4", __assign({ className: "pb-2 uppercase" }, { children: isAdminCreation
                                                    ? t("LBL_PASSWORD", { ns: "Users" })
                                                    : t("LBL_CHANGE_PASSWORD_TITLE", { ns: "Users" }) })) })) }) })) })), !isAdminCreation && (_jsx("div", __assign({ id: "generate_password_old_password", className: "mt-4" }, { children: _jsx("table", __assign({ width: "100%" }, { children: _jsxs("tr", { children: [_jsx("td", __assign({ width: "25%" }, { children: t("LBL_OLD_PASSWORD", { ns: "Users" }) })), _jsx("td", { children: _jsx(Input, { name: "old_password", id: "old_password", type: "password", className: "mb-4", value: passValue === null || passValue === void 0 ? void 0 : passValue.old, onChange: changeOldPasword }) }), _jsx("td", __assign({ width: "40%" }, { children: oldRequired && (_jsx("div", __assign({ className: "text-red-500 ml-4" }, { children: t("L'ancien mot de passe est obligatoire", {
                                                        ns: "Users",
                                                    }) }))) }))] }) })) }))), _jsx("div", __assign({ id: "", className: "mt-4" }, { children: _jsxs("table", __assign({ width: "100%" }, { children: [_jsxs("tr", { children: [_jsxs("td", __assign({ width: "25% " }, { children: [t("LBL_NEW_PASSWORD", { ns: "Users" }), isAdminCreation && (_jsx("span", __assign({ className: "pl-1 text-[rgb(var(--color-red-500))]" }, { children: "*" })))] })), _jsx("td", __assign({ className: "dataField" }, { children: _jsx(Input, { name: "new_password", id: "new_password", type: "password", className: "mb-4", value: passValue === null || passValue === void 0 ? void 0 : passValue.new, onChange: changeNewPasword }) })), _jsx("td", __assign({ width: "40%" }, { children: passwordError && (_jsx("div", __assign({ id: "comfirm_pwd_match", className: "text-red-500 ml-4" }, { children: passwordError }))) }))] }), _jsxs("tr", { children: [_jsx("td", __assign({ scope: "row", width: "25%" }, { children: t("LBL_CONFIRM_PASSWORD", { ns: "Users" }) })), _jsx("td", __assign({ className: "dataField" }, { children: _jsx(Input, { name: "confirm_new_password", id: "confirm_pwd", type: "password", className: "mb-4", value: passValue === null || passValue === void 0 ? void 0 : passValue.confirm, onChange: changeConfirmPasword }) })), _jsx("td", __assign({ width: "40%" }, { children: !isMatch && (_jsx("div", __assign({ id: "comfirm_pwd_match", className: "text-red-500 ml-4" }, { children: t("ERR_PASSWORD_MISMATCH", { ns: "Users" }) }))) }))] }), _jsxs("tr", { children: [_jsx("td", { className: "dataLabel" }), _jsx("td", { className: "dataField" })] })] })) }))] })) }) })) })) }));
};
